var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
              nativeOn: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleSearchBtn.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "xhname" } },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "selectRef",
                          staticClass: "model-select",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "popper-append-to-body": "",
                            "reserve-keyword": "",
                            "automatic-dropdown": true,
                            "default-first-option": true,
                            placeholder: "请输入轴承型号",
                            "remote-method": _vm.remoteMethod,
                            loading: _vm.loading,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.keyword,
                            callback: function ($$v) {
                              _vm.keyword = $$v
                            },
                            expression: "keyword",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleSearchBtn },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetBtn },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table search-table" },
        [
          _c(
            "el-table",
            {
              staticClass: "customer-table",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
              },
            },
            [
              _c("el-table-column", { attrs: { label: "ID", prop: "id" } }),
              _c("el-table-column", {
                attrs: { label: "订单号", prop: "orderid" },
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
              }),
              _c("el-table-column", { attrs: { label: "数量", prop: "num" } }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
              }),
              _c("el-table-column", {
                attrs: { label: "货期", prop: "sendtime" },
              }),
              _c("el-table-column", {
                attrs: { label: "报价公司", prop: "company" },
              }),
              _c("el-table-column", {
                attrs: { label: "负责人", prop: "rname" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              disabled:
                                row.state === "T" ||
                                _vm.disabledIndexes.includes(row.id),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addToDrawer(row, $index)
                              },
                            },
                          },
                          [_vm._v("添加 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "生成合同",
            visible: _vm.drawerVisible,
            size: _vm.getIsMobile ? "100%" : "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "drawer-table",
              attrs: { data: _vm.addedData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "xhname", label: "型号" },
              }),
              _c("el-table-column", {
                attrs: { prop: "source", label: "品牌" },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "5px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleContract(_vm.addedData)
                    },
                  },
                },
                [_vm._v("生成合同")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "5px" },
                  attrs: { type: "danger" },
                  on: { click: _vm.handleClear },
                },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "add-btn",
          attrs: { type: "primary", plain: "" },
          on: { click: _vm.handleAddXname },
        },
        [
          _vm._v(
            "已添加（" + _vm._s(_vm.addedData.length || _vm.addedNum) + "） "
          ),
        ]
      ),
      _c("CreateContract", {
        attrs: {
          dialog: _vm.contractDialog,
          data: _vm.contractData,
          companyId: _vm.companyId,
        },
        on: { close: _vm.contractClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }